import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _set from 'lodash/set';
// @ts-ignore
import stringify from 'json-stable-stringify';
export default class ObjectUtil {
    static exists(object) {
        return typeof object !== 'undefined';
    }
    static get(object, path) {
        return _get(object, path);
    }
    static set(object, path, value) {
        return _set(object, path, value);
    }
    static removeKeysWithUndefined(object) {
        let cloned = Object.assign({}, object);
        let removedKeys = [];
        Object.keys(object).forEach((key) => {
            if (cloned[key] === undefined) {
                removedKeys.push(key);
            }
        });
        removedKeys.forEach((removedKey) => {
            delete cloned[removedKey];
        });
        return cloned;
    }
    static clone(o) {
        return cloneDeep(o);
    }
    static isStrictEqual(o1, o2) {
        return stringify(o1) === stringify(o2);
    }
}
export { ObjectUtil };
